(function () {
    'use strict';

    angular.module('doclr.pivot.api', [])
        .factory('Pivot', ['DoclrHttp', 'AppConfigService', 'praktijkContext', '$http', function (DoclrHttp, AppConfigService, praktijkContext, $http) {
            return {
                getData: getData,
                downloadAppointmentsExport: downloadAppointmentsExport
            };

            function getData() {
                return DoclrHttp.get('/apiv0/pivot/' + praktijkContext.id);
            }

            function downloadAppointmentsExport(from, to) {
                return $http.get(AppConfigService.getApiUrl() + '/api/calendar/v1/party/' + praktijkContext.id + '/appointment/export/excel', {
                    params: {from: from, to: to},
                    responseType: 'arraybuffer'
                });
            }
        }]);
})();